import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

export default function DateSingle(props) {
  const { userParams, setUserParams } = props;
  var justym = userParams.datePickerViews && userParams.datePickerViews.toString() === 'year,month';

  const handleDateChange = (name) => event => {
    const dt = event;
    setUserParams({ ...userParams, [name]: dt})
  }

  return (
    <>
        <DatePicker 
          label="Date"
          value={userParams.fromDate}
          views={userParams.datePickerViews || ['year','month','day']}
          onChange={handleDateChange("fromDate")}
          format={justym ? "YYYY-MM" : "YYYY-MM-DD"}
          minDate={dayjs('1895-1-1')}
          maxDate={dayjs()}
          slotProps={{ textField: { sx: { width: "10rem" } } }}
        />
    </>
  )
}